/**
 * Financial Navigation Hub
 *
 * Landing page for the financial section that redirects to Big Numbers by default.
 */

import { useNavigate } from '@tanstack/react-router'
import { useEffect } from 'react'

export default function FinancialPage() {
  const navigate = useNavigate()

  useEffect(() => {
    // Redirect to Big Numbers page by default
    void navigate({ to: '/financial/big-numbers' })
  }, [navigate])

  // Show loading while redirecting
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="text-center space-y-4">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-brand-primary mx-auto"></div>
        <p className="text-brand-gray-light font-body">Redirecionando...</p>
      </div>
    </div>
  )
}
